import {Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export enum AddressType {
	STRUCTURED = "S",
	COMBINED_ELEMENTS = "K",
}

export class SwissQrCodeFormAddress implements Parameter {
	public type: AddressType;
	public name: string;
	public addressLine1: string;
	public addressLine2: string;
	public street: string;
	public houseNumber: string;
	public postalCode: string;
	public location: string;
	public countryCode: string;

	constructor(data: any) {
		let addressType: AddressType = AddressType.STRUCTURED;
		if (FunctionHelper.exists(data?.addressLine1) || FunctionHelper.exists(data?.addressLine2)) {
			addressType = AddressType.COMBINED_ELEMENTS;
		}

		this.type = FunctionHelper.exists(data?.type) ? data.type : addressType;
		this.name = FunctionHelper.exists(data?.name) ? data.name : "";
		this.addressLine1 = FunctionHelper.exists(data?.addressLine1) ? data.addressLine1 : "";
		this.addressLine2 = FunctionHelper.exists(data?.addressLine2) ? data.addressLine2 : "";
		this.street = FunctionHelper.exists(data?.street) ? data.street : "";
		this.houseNumber = FunctionHelper.exists(data?.houseNumber) ? data.houseNumber : "";
		this.postalCode = FunctionHelper.exists(data?.postalCode) ? data.postalCode : "";
		this.location = FunctionHelper.exists(data?.location) ? data.location : "";
		this.countryCode = FunctionHelper.exists(data?.countryCode) ? data.countryCode : "";
	}

	public static getTypeDefault(): AddressType {
		return AddressType.STRUCTURED;
	}

	public static getNameDefault(): string {
		return "";
	}

	public static getAddressLine1Default(): string {
		return "";
	}

	public static getAddressLine2Default(): string {
		return "";
	}

	public static getStreetDefault(): string {
		return "";
	}

	public static getHouseNumberDefault(): string {
		return "";
	}

	public static getPostalCodeDefault(): string {
		return "";
	}

	public static getLocationDefault(): string {
		return "";
	}

	public static getCountryCodeDefault(): string {
		return "";
	}

	public static fromJson(data: any): SwissQrCodeFormAddress {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new SwissQrCodeFormAddress(data);
	}

	public toJson(): any {
		return {
			'type': this.type,
			'name': this.name,
			'addressLine1': this.addressLine1,
			'addressLine2': this.addressLine2,
			'street': this.street,
			'houseNumber': this.houseNumber,
			'postalCode': this.postalCode,
			'location': this.location,
			'countryCode': this.countryCode,
		};
	}

	public clone(): SwissQrCodeFormAddress {
		return SwissQrCodeFormAddress.fromJson(this.toJson());
	}
}